import { Component, Input } from '@angular/core';
import { UICardModule } from '@homepower-co/shared-ui-angular';

@Component({
  selector: 'app-team-density-card',
  standalone: true,
  imports: [UICardModule],
  templateUrl: './team-density-card.component.html',
  styleUrls: ['./team-density-card.component.scss'],
})
export class TeamDensityCardComponent {
  @Input() frontend = 35;
  @Input() backend = 42;
  @Input() transversal = 12;
  @Input() design = 11;
}
